export const retailAccountKeys = {
  all:     ()                              => ['retail-accounts']                                    as const,
  content: (id: string)                   => ['retail-accounts', id, 'content']                     as const,
  history: (id: string, range: string)    => ['retail-accounts', id, 'history', range]              as const,
  historyAll: (id: string)                => ['retail-accounts', id, 'history']                     as const,
  bars:    (id: string, symbol: string, range: string) => ['retail-accounts', id, 'bars', symbol, range] as const,
  profile: (id: string, symbol: string)   => ['retail-accounts', id, 'profile', symbol]             as const,
  series:  (id: string, range: string)    => ['retail-accounts', id, 'portfolio-series', range]      as const,
  transactions: (id: string, symbol: string) => ['retail-accounts', id, 'transactions', symbol]      as const,
};

export const onboardingKeys = {
  status: () => ['onboarding', 'status'] as const,
};

export const appFeatureKeys = {
  web: () => ['app-features', 'web'] as const,
};

export const investorKeys = {
  gateStatus: () => ['investor', 'gate-status'] as const,
  livePerf:   () => ['investor', 'live-perf']   as const,
  simulation: () => ['investor', 'simulation']  as const,
};

export const authKeys = {
  inviteValidate:        (hash: string)  => ['auth', 'invite', hash]          as const,
  resetPasswordValidate: (token: string) => ['auth', 'reset-password', token] as const,
};
